import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  offsets: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.VIEWPORT__CHANGED: {
      return {
        ...state,
        offsets: {
          ...state.offsets,
          ...action.payload.offsets,
        },
      };
    }
    default:
      return state;
  }
};
